<template>
	<div class="planner-datebar" aria-label="Day and Week Navigation">
		<div :class="{ 'container': viewMode === 'day', 'container-fluid': viewMode === 'week' }">
			<div class="planner-date-controls">
				<button class="btn planner-date-btn planner-date-btn-prev" :disabled="!prevWeekEnabled" @click="prevWeekClicked">
					<span class="ico-arrow-left icon-adjust-horiz icon-adjust-vert"></span>
					<span class="sr-only">Previous Week</span>
				</button>
				<div class="planner-date-week">
					<div class="planner-date" :class="{'planner-date-current': day.today, 'planner-date-no-results': day.noResults}" v-for="day of days" :key="day.index">
						<div class="sr-only" :id="`day-total-${day.index}`">{{ day.display.total }} results</div>
						<div class="planner-date-month" aria-hidden="true" v-show="viewMode === 'week'">{{ day.display.month }}</div>
						<div class="planner-date-month" aria-hidden="true" v-show="viewMode !== 'week'">{{ day.display.monthAbbr }}</div>
						<label v-show="viewMode === 'day'" class="planner-date-radio" data-testid="plannerDate" :for="`day-${day.index}`" :aria-label="day.display.ariaDate" :aria-describedby="`day-total-${day.index}`">
							<input
								:id="`day-${day.index}`"
								type="radio"
								:value="day.value"
								v-model="selectedNavDay"
								class="planner-date-radio-input"
								@change="selectedChanged"
							/>
							<span class="planner-date-day">
								<span class="planner-date-dayname">
									<span class="hidden-lg-up">{{ day.display.dayLetter }}</span>
									<span class="hidden-md-down">{{ day.display.dayName }}</span>
								</span>
								<span class="planner-date-number">{{ day.display.dayNum }}</span>
							</span>
						</label>

						<div v-show="viewMode === 'week'" class="planner-date-display">
							<div>{{ day.display.dayNameFull }}</div>
							<div>{{ day.display.dayNum }}</div>
						</div>
					</div>
				</div>
				<button class="btn planner-date-btn planner-date-btn-next" :disabled="!nextWeekEnabled" @click="nextWeekClicked">
					<span class="ico-arrow-right icon-adjust-horiz icon-adjust-vert"></span>
					<span class="sr-only">Next Week</span>
				</button>
			</div>
		</div>
	</div>
</template>

<script>
import { defineComponent } from 'vue';
import { momentProvider } from '@/services/clock.service';

export default defineComponent({
	name: 'DateBarSub',
	props: {
		viewMode: {
			default: 'day',
			type: String
		},
		days: {
			default: () => [],
			type: Array
		},
		selectedDate: {
			default: null,
			type: Object
		}
	},
	data() {
		return {
			selectedNavDay: null,
			prevWeekEnabled: false,
			nextWeekEnabled: false,
			maxDay: null
		};
	},
	watch: {
		selectedDate: function(newSelectedDate) {
			this.selectedNavDay = newSelectedDate.format('YYYY-MM-DD');
			this.enableDisableWeekNav();
		}
	},
	mounted() {
		this.selectedNavDay = this.selectedDate.format('YYYY-MM-DD');
		this.maxDay = momentProvider().add(import.meta.env.VITE_MAX_DAYS_CLASSES_FORWARD, 'days');
		this.enableDisableWeekNav();
	},
	methods: {
		enableDisableWeekNav() {
			this.prevWeekEnabled = momentProvider().startOf('week').isBefore(this.selectedDate.clone().startOf('week'));
			this.nextWeekEnabled = this.maxDay.clone().endOf('week').isAfter(this.selectedDate.clone().endOf('week'));
		},
		selectedChanged() {
			this.$emit('dayChanged', this.selectedNavDay);
		},
		prevWeekClicked() {
			this.$emit('weekChanged', this.selectedDate.clone().subtract(1, 'weeks').format('YYYY-MM-DD'));
		},
		nextWeekClicked() {
			this.$emit('weekChanged', this.selectedDate.clone().add(1, 'weeks').format('YYYY-MM-DD'));
		}
	}
});
</script>

<style lang="scss" scoped>
@import "../styles/dateBar.scss";
</style>
